import { FiAlertTriangle } from "react-icons/fi";
import styles from "./ConfirmCancelModal.module.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ConfirmCancelModal = ({
                                isOpen,
                                onConfirm,
                                onCancel,
                                message,
                                confirmText,
                                cancelText,
                                disabled = false,
                                requireReason = false,
                            }) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState("");

    useEffect(() => {
        if (isOpen) {
            setReason("");
        }
    }, [isOpen]);

    const handleReasonChange = (e) => {
        setReason(e.target.value);
    };

    const isConfirmDisabled = disabled || (requireReason && reason.trim().length === 0);

    const handleConfirm = () => {
        onConfirm(reason.trim());
    };

    if (!isOpen) return null;

    const resolvedConfirmText = confirmText ?? t("common.cancel");
    const resolvedCancelText = cancelText ?? t("common.close");

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.iconWrap}>
                        <FiAlertTriangle className={styles.icon} aria-hidden />
                    </div>
                    <h3 className={styles.title}>{t("common.confirmTitle")}</h3>
                </div>

                <p className={styles.message}>{message}</p>

                {requireReason && (
                    <div className={styles.formGroup}>
                        <label htmlFor="cancel-reason" className={styles.label}>
                            {t("modals.cancelReasonLabel")}
                        </label>
                        <textarea
                            id="cancel-reason"
                            name="note"
                            value={reason}
                            onChange={handleReasonChange}
                            className={styles.textarea}
                            rows={4}
                            placeholder={t("modals.cancelReasonPlaceholder")}
                        />
                    </div>
                )}

                <div className={styles.actions}>
                    <button
                        type="button"
                        className={styles.cancelBtn}
                        onClick={onCancel}
                    >
                        {resolvedCancelText}
                    </button>

                    <button
                        type="button"
                        className={styles.confirmBtn}
                        onClick={handleConfirm}
                        disabled={isConfirmDisabled}
                    >
                        {resolvedConfirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmCancelModal;
